import { render, staticRenderFns } from "./ImproperWarning.vue?vue&type=template&id=715e44b9&"
import script from "./ImproperWarning.vue?vue&type=script&lang=js&"
export * from "./ImproperWarning.vue?vue&type=script&lang=js&"
import style0 from "./ImproperWarning.vue?vue&type=style&index=0&id=715e44b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports